import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchHeader from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-header/grossing-touch-header.vue'
import GrossingTouchSamplePendingCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sample-pending-card/grossing-touch-sample-pending-card.vue'
import GrossingTouchSidebar from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-sidebar/grossing-touch-sidebar.vue'

@Component({
    components: {
        GrossingTouchHeader,
        GrossingTouchSamplePendingCard,
        GrossingTouchSidebar
    }
})
export default class GrossingTouchPendingView extends Vue {
    private grossingPendingSamples !: Array<object>

    constructor() {
        super()
        this.grossingPendingSamples = [
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H3B21-000056-A',
                priority: 1,
                grossingResponsible: 'FERNÁNDEZ HERNÁNDEZ MARÍA',
                pathologist: 'SÁNCHEZ GARCÍA VERÓNICA'
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H3B21-000056-A',
                priority: 0,
                grossingResponsible: 'FERNÁNDEZ HERNÁNDEZ MARÍA',
                pathologist: 'SÁNCHEZ GARCÍA VERÓNICA'
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H3B21-000056-A',
                priority: 0,
                grossingResponsible: 'FERNÁNDEZ HERNÁNDEZ MARÍA',
                pathologist: 'SÁNCHEZ GARCÍA VERÓNICA'
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H3B21-000056-A',
                priority: 1,
                grossingResponsible: 'FERNÁNDEZ HERNÁNDEZ MARÍA',
                pathologist: 'SÁNCHEZ GARCÍA VERÓNICA'
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H3B21-000056-A',
                priority: 1,
                grossingResponsible: 'FERNÁNDEZ HERNÁNDEZ MARÍA',
                pathologist: 'SÁNCHEZ GARCÍA VERÓNICA'
            },
            {
                location: 'Piel abdominal',
                sampleType: 'Biopsia incisional',
                registryDate: '11/03/2022 14:16',
                label: 'H3B21-000056-A',
                priority: 2,
                grossingResponsible: 'FERNÁNDEZ HERNÁNDEZ MARÍA',
                pathologist: 'SÁNCHEZ GARCÍA VERÓNICA'
            }
        ]
    }
}
